import { render, staticRenderFns } from "./freight.vue?vue&type=template&id=2110d2f2&scoped=true"
import script from "./freight.vue?vue&type=script&lang=js"
export * from "./freight.vue?vue&type=script&lang=js"
import style0 from "./freight.vue?vue&type=style&index=0&id=2110d2f2&prod&lang=stylus&scoped=true"
import style1 from "./freight.vue?vue&type=style&index=1&id=2110d2f2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2110d2f2",
  null
  
)

export default component.exports